<template>
  <div id="footer" class="footer">
    <div class="left">
      <p class="contact">{{ $t('footer.static.contact.label') }}</p>
      <template v-for="(contact, index) in contacts">
        <div class="item" :key="index">
          <i :class="contact.icon" />
          <p>{{ contact.label }}</p>
        </div>
      </template>
    </div>
    <div class="center">
      <p class="copyright">{{ $t('footer.static.copyright.label') }}</p>
      <a class="beian" :href="beian.url" target="blank">{{ beian.id }}</a>
    </div>
    <div class="right">
      <div class="qrcode">
        <img class="image" :src="qrsales" />
        <p class="label">{{ $t('footer.static.qrsales.label') }}</p>
      </div>
      <div class="qrcode">
        <img class="image" :src="qrpubacc" />
        <p class="label">{{ $t('footer.static.qrpubacc.label') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contacts: [
        { prop: 'phone', label: this.$t('footer.static.contact.phone'), icon: 'el-icon-phone-outline' },
        { prop: 'mail', label: this.$t('footer.static.contact.mail'), icon: 'el-icon-message' }
      ],
      beian: {
        url: 'https://beian.miit.gov.cn/',
        id: '粤ICP备10201584号'
      }
    }
  },
  computed: {
    qrsales: function() {
      return require('@/assets/qrcode.sales.png')
    },
    qrpubacc: function() {
      return require('@/assets/qrcode.pubacc.png')
    }
  }
}
</script>

<style scoped>
.footer {
  width: 100%;
  height: var(--footer-height);
  padding: 1rem 2rem;
  background: #171f25;
  color: #798893;

  display: flex;
  flex-direction: row;
}

.footer .left {
  width: 30%;
  height: 100%;
  padding: 0 4rem;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.footer .right {
  width: 20%;
  height: 100%;

  display: flex;
  flex-direction: row;
  align-items: flex-end;
}
.footer .center {
  width: 50%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.left .contact {
  font-size: 1.4rem;
}
.left .item {
  padding: 0.2rem;
  font-size: 1.2rem;
}

.right .qrcode {
  padding-left: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qrcode .image {
  width: 10rem;
  height: 10rem;
}
.qrcode .label {
  font-size: 1.4rem;
  /* writing-mode: vertical-lr; */
}

.center .copyright {
  font-size: 1.4rem;
}
.center .beian {
  font-size: 1rem;
}
</style>
